<script setup lang="ts">
// Generic collapsible disclosure - the SINGLE fold chrome (chevron + summary
// row + collapsible body) shared by ToolFold ("Used N tools") and tool
// viewparts (e.g. WebResults "Sources"). Uncontrolled + collapsed by default so
// rich content doesn't pollute the thread; the user clicks the summary to
// expand (no bound `open` - a reactive binding would snap shut on every
// streaming re-render). Summary content in the `summary` slot, body in default.
// The chevron icon is injected (caretRight) so each app uses its own icon set.
import { useIcons } from '../icons';

const icons = useIcons();
</script>

<template>
  <details class="fold">
    <summary class="fold__summary">
      <component :is="icons.caretRight" :size="13" class="fold__chevron" />
      <slot name="summary" />
    </summary>
    <div class="fold__body"><slot /></div>
  </details>
</template>

<style scoped>
.fold {
  margin-top: var(--space-2);
  font-size: var(--text-xs);
  color: var(--ink-muted);
}
.fold__summary {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  cursor: pointer;
  list-style: none;
  user-select: none;
  color: var(--ink-muted);
}
.fold__summary::-webkit-details-marker { display: none; }
.fold__summary:hover { color: var(--ink-primary); }
.fold[open] .fold__chevron { transform: rotate(90deg); }
.fold__chevron { flex: 0 0 auto; transition: transform 120ms ease; }
</style>
